module.exports = __webpack_public_path__ + "img/ai-image.5216df3e.svg";